import React from "react";
import "./Footer.css";

export const Footer = () => {
  return (
    <div className="footer">
      <p className="copyright">© Conference Organisers</p>
      <p className="design">Design by ADVANCE CRT</p>
    </div>
  );
};
